<template>
  <div class="search_ui" :style="styleBg">
    <div class="search-box" @click="goSeacher" :style="style">
      <p :style="textStyle"><i class="iconfont iconsousuo"></i>请输入搜索的内容</p>
     
    </div>
  </div>
</template>

<script>
import { jAlert3 } from "@/base/jAlert/jAlert";

export default {
  props: ["datas"],
  data() {
    return {};
  },
   computed: {
    styleBg(){
      return `background:${this.datas.bgColor};`
    },
    style() {
      var bRadius = '0.053333';
      if(this.datas.bType=='1'){
         bRadius = this.datas.bHeight/75
        
      }
      return `width:${this.datas.bWidth}%;border-radius:${bRadius}rem;height:${this.datas.bHeight/37.5}rem;background-color:${this.datas.bBackColor};opacity:${this.datas.bOpacity/100}`
			
    },
    textStyle(){
        return `color:${this.datas.textColor};text-align:${this.datas.textAlign};height:${this.datas.bHeight/37.5}rem;line-height:${this.datas.bHeight/37.5}rem;`
    }
  },
 
  methods: {
    
    goSeacher(){
       this.$router.push({
        path: "/searchIndex",
      });
    }
  },
};
</script>
<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");
.search_ui {
  display: flex;
  justify-content: center;
  padding: 0 0.426667rem;
  .search-box {
    width: 100%;
    position: relative;
    border-radius: 0.50654rem;
    height: 1.01308rem;
    line-height:1.01308rem;
    overflow: hidden;
    font-size: 14px;
    
    p {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      font-size: 14px;
      padding: 0 0.533333rem;
      align-items: center;
      font-size: 14px;
      color: #ffffff;
      border-radius: 0.50654rem;
      i{
        font-size: 14px;
        margin-right: 0.133333rem;
      }
    
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Search.vue